import playerCard from "../assets/player_card.png";
import clubCard from "../assets/club_card.png";
import crewCard from "../assets/crew_card.png";
import venueCard from "../assets/venue_card.png";
import secureLocalStorage from "react-secure-storage";
import profile1 from "../assets/profile1.jpg";
import profile2 from "../assets/profile2.jpg";
import profile3 from "../assets/profile3.jpg";
import profile4 from "../assets/profile4.webp";
import profile5 from "../assets/profile5.webp";
import gameIcon from "../assets/game.png";
import notepad from "../assets/notepad.png";
import partner from "../assets/partners.png";
import badminton from "../assets/badminton.png";
import Cookies from "js-cookie";
export const playercards = [
  {
    id: 1,
    title: "Player Cards",
    description: "Cards posted by Players",
    image: playerCard,
    badge: 487,
    route: "/cards/sport",
  },
  {
    id: 2,
    title: "Club Cards",
    description: "Cards posted by Clubs",
    image: clubCard,
    route: "/cards/club",
  },
  {
    id: 3,
    title: "Crew Cards",
    description: "Cards posted by Crew",
    image: crewCard,
    route: "/cards/crew",
  },
  {
    id: 4,
    title: "Venue Cards",
    description: "Cards posted by Venues",
    image: venueCard,
    route: "/cards/venue",
  },
];

export const playerFilter = ["Beginner", "Intermediate", "Advanced", "Any"];

// export const ageOptions = [
//   "U10",
//   "U12",
//   "U14",
//   "U16",
//   "U18",
//   "Adult",
//   "Senior",
//   "All Ages",
// ];

export const genderOptions = [
  { id: "Male", name: "♂️ Male" },
  { id: "Female", name: "♀️ Female" },
  { id: "Mixed", name: "⚧️ Mixed" },
  { id: "All Genders", name: "🌈 All Genders" },
];
export const EVENT_GENDERS = [
  { id: "Male", name: "♂️  Male" },
  { id: "Female", name: "♀️  Female" },
  { id: "Any(All Genders)", name: "⚧️  Any(All Genders)" },
  { id: "Non-binary/other", name: "🏳️‍⚧️  Non-binary/other" },
  { id: "Prefer not to say", name: "🔒  Prefer not to say" },
];

export const gamesSportOptions = [
  "American Football",
  "Archery",
  "Athletics (Track & Field)",
  "Australian Football",
  "Auto Racing",
  "Badminton",
  "Baseball",
  "Basketball",
  "Billiards / Pool",
  "Bowling / Tenpin",
  "Bowls",
  "Boxing",
  "Carrom Board",
  "Chess",
  "Cricket",
  "CrossFit / Functional Training",
  "Curling",
  "Cycling",
  "Dance Fitness / Zumba",
  "Darts",
  "Dodgeball",
  "Dragon Boating",
  "Equestrian",
  "Esports",
  "Fencing",
  "Fishing (Sport)",
  "Football / Soccer",
  "Futsal",
  "Golf",
  "Fitness/Gym",
  "Gymnastics",
  "Handball",
  "Hockey (Field)",
  "Ice Hockey",
  "Judo",
  "Kabaddi",
  "Karting",
  "Kayaking / Canoeing",
  "Lacrosse",
  "Martial Arts (Karate / Taekwondo / MMA)",
  "Motocross",
  "Motorcycle Racing",
  "Motorsport (General)",
  "Mountain Biking",
  "Netball",
  "Orienteering",
  "Padel",
  "Pickleball",
  "Pilates",
  "Polo",
  "Rally",
  "Rowing",
  "Rugby League",
  "Rugby Union",
  "Sailing",
  "Skateboarding",
  "Skating (Roller / Ice)",
  "Skiing",
  "Snow Games",
  "Snowboarding",
  "Softball",
  "Squash",
  "Surfing",
  "Swimming",
  "Table Tennis",
  "Tennis",
  "Triathlon",
  "Ultimate Frisbee",
  "Volleyball",
  "Water Polo",
  "Wrestling",
  "Yoga",
  "Others",
];

export const sportPlayerData = [
  {
    id: "PCZ1757599658377",
    name: "Lionel Messi",
    sportName: "Football",
    initial: "L",
    description:
      " Lorem Ipsum is that it has a more-or-less normal distribution of letters",
    achievement:
      "6 Ballon d'Or, 4 Champions League titles6 Ballon d'Or, 4 Champions League titles6 Ballon d'Or, 4 Champions League titles",
    skillLevel: "Advanced",
    location:
      "Barcelona, Spain Barcelona, SpainBarcelona, SpainBarcelona, SpainBarcelona, SpainBarcelona, SpainBarcelona, SpainBarcelona, SpainBarcelona, Spain",
  },
  {
    id: "PCZ1757599658378",
    name: "Cristiano Ronaldo",
    sportName: "Football",
    initial: "C",
    description:
      " Lorem Ipsum is that it has a more-or-less normal distribution of letters",
    achievement: "5 Ballon d'Or, 5 Champions League titles",
    skillLevel: "Advanced",
    location: "Manchester, UK",
  },
  {
    id: "PCZ1757599658379",
    name: "LeBron James",
    sportName: "Basketball",
    initial: "L",
    description:
      " Lorem Ipsum is that it has a more-or-less normal distribution of letters",
    achievement: "4 NBA Championships, 4 MVP Awards",
    skillLevel: "Advanced",
    location: "Los Angeles, USA",
  },
  {
    id: "PCZ1757599658380",
    name: "Serena Williams",
    sportName: "Tennis",
    initial: "S",
    description:
      " Lorem Ipsum is that it has a more-or-less normal distribution of letters",
    achievement: "23 Grand Slam singles titles",
    skillLevel: "Advanced",
    location: "Palm Beach Gardens, USA",
  },
  {
    id: "PCZ1757599658381",
    name: "Sachin Tendulkar",
    sportName: "Cricket",
    initial: "S",
    description:
      " Lorem Ipsum is that it has a more-or-less normal distribution of letters",
    achievement: "100 international centuries, 200 Tests",
    skillLevel: "Advanced",
    location: "Mumbai, India",
  },
  {
    id: "PCZ1757599658382",
    name: "Wayne Gretzky",
    sportName: "Ice Hockey",
    description:
      " Lorem Ipsum is that it has a more-or-less normal distribution of letters",
    initial: "W",
    achievement: "4 Stanley Cups, 9 MVP Awards",
    skillLevel: "Advanced",
    location: "Los Angeles, USA",
  },
  {
    id: "PCZ1757599658383",
    name: "Michael Phelps",
    sportName: "Swimming",
    initial: "M",
    description:
      " Lorem Ipsum is that it has a more-or-less normal distribution of letters",
    achievement: "23 Olympic gold medals",
    skillLevel: "Advanced",
    location: "Baltimore, USA",
  },
  {
    id: "PCZ1757599658384",
    name: "Usain Bolt",
    sportName: "Athletics (Sprinting)",
    initial: "U",
    description:
      "they cannot foresee the pain and trouble that are bound to ensue; and equal blame belongs to those who fail in their duty through weakness of will,",
    achievement: "8 Olympic gold medals, 3 world records",
    skillLevel: "Advanced",
    location: "Kingston, Jamaica",
  },
  {
    id: "PCZ1757599658385",
    name: "Simone Biles",
    sportName: "Gymnastics",
    initial: "S",
    description:
      " Lorem Ipsum is that it has a more-or-less normal distribution of letters",
    achievement: "7 Olympic medals, 19 World Championship titles",
    skillLevel: "Advanced",
    location: "Columbus, USA",
  },
  {
    id: "PCZ1757599658386",
    name: "Tom Brady",
    sportName: "American Football",
    initial: "T",
    description:
      "The majority have suffered alteration in some form, by injected humour",
    achievement: "7 Super Bowl titles",
    skillLevel: "Advanced",
    location: "Tampa, USA",
  },
];

// community
export const communityData = [
  {
    id: 1,
    name: "Biden",
    type: "member",
    age: 33,
    gender: "Male",
    primarySport: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    additionalSports: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    location: "70 Washington Square South, New York, NY 10012, United States",
    memberSince: "2020",
    subtitle: "Crew",
    image:
      "https://images.unsplash.com/photo-1511367461989-f85a21fda167?w=400&h=400&fit=crop",
    rating: 4.8,
    online: true,
    matchesPlayed: 145,
    club: "Baseball",
    description:
      " If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
    organisation: [
      { club: "Baseball Club", role: "Team Leader" },
      { club: "Football Club", role: "Member" },
    ],
    certifications: [
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
    ],
  },
  {
    id: 2,
    name: "Trump",
    type: "member",
    age: 33,
    gender: "Male",
    primarySport: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    additionalSports: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    location: "70 Washington Square South, New York, NY 10012, United States",
    memberSince: "2020",
    subtitle: "Venue",
    image:
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=400&fit=crop",
    rating: 4.6,
    online: false,
    matchesPlayed: 145,
    description:
      " If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
    organisation: [
      { club: "Baseball Team", role: "Member" },
      { club: "Badminton League", role: "Captain" },
    ],
    certifications: [
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
    ],
  },
  {
    id: 3,
    name: "Athlosmax",
    type: "member",
    age: 33,
    gender: "Female",
    primarySport: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    additionalSports: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    location: "Los Angeles, USA",
    memberSince: "2020",
    subtitle: "Club",
    image:
      "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=400&h=400&fit=crop",
    rating: 4.9,
    online: true,
    matchesPlayed: 145,
    description:
      " If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
    organisation: [
      { club: "Baseball Elite", role: "Team Captain" },
      { club: "Auto Racing Club", role: "Member" },
    ],
    certifications: [
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
    ],
  },
  {
    id: 4,
    name: "Chris Evans",
    type: "playmate",
    age: 33,
    gender: "Male",
    // primarySport: "Baseball",
    primarySport: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    additionalSports: [
      "Football sss",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
      "Football sss",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
      "Football sss",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
      "Football sss",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
      "Football sss",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
      "Football sss",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
      "Football sss",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    location: "Chicago, USA",
    memberSince: "2020",
    subtitle: "Player",
    image:
      "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=400&h=400&fit=crop",
    rating: 4.7,
    online: true,
    matchesPlayed: 145,
    description:
      "If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
    organisation: [
      { club: "Football Squad", role: "Quarterback" },
      { club: "Baseball Crew", role: "Pitcher" },
    ],
    certifications: [
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
    ],
  },
  {
    id: 5,
    name: "Emma Watson",
    type: "playmate",
    age: 33,
    gender: "Female",
    primarySport: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    additionalSports: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    location: "Miami, USA",
    memberSince: "2020",
    subtitle: "Club",
    image:
      "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=400&h=400&fit=crop",
    rating: 4.9,
    online: false,
    matchesPlayed: 145,
    description:
      " If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
    organisation: [
      { club: "Basketball League", role: "Forward" },
      { club: "Baseball Team", role: "Catcher" },
    ],
    certifications: [
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
    ],
  },
  {
    id: 6,
    name: "John Wick",
    type: "playmate",
    age: 33,
    gender: "Male",
    primarySport: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    additionalSports: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    location: "Seattle, USA",
    memberSince: "2020",
    subtitle: "Crew",
    image:
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop",
    rating: 5.0,
    online: true,
    matchesPlayed: 145,
    description:
      " If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
    organisation: [
      { club: "American Football", role: "Running Back" },
      { club: "Baseball Crew", role: "Pitcher" },
    ],
    certifications: [
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
    ],
  },
  {
    id: 7,
    name: "Scarlett J",
    type: "playmate",
    age: 33,
    gender: "Female",
    primarySport: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    additionalSports: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    location: "Boston, USA",
    memberSince: "2020",
    subtitle: "Venue",
    image:
      "https://images.unsplash.com/photo-1525134479668-1bee5c7c6845?w=400&h=400&fit=crop",
    rating: 4.8,
    online: true,
    matchesPlayed: 145,
    description:
      " If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
    organisation: [
      { club: "Baseball Team", role: "Captain" },
      { club: "Basketball League", role: "Shooting Guard" },
    ],
    certifications: [
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
    ],
  },
  {
    id: 8,
    name: "Chris Evans",
    type: "playmate",
    age: 33,
    gender: "Male",
    primarySport: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    additionalSports: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    location: "Chicago, USA",
    memberSince: "2020",
    subtitle: "Player",
    image:
      "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=400&h=400&fit=crop",
    rating: 4.7,
    online: true,
    matchesPlayed: 145,
    description:
      " If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
    organisation: [
      { club: "American Football Club", role: "Quarterback" },
      { club: "Baseball Team", role: "Catcher" },
    ],
    certifications: [
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
    ],
  },
  {
    id: 9,
    name: "Emma Watson",
    type: "playmate",
    age: 33,
    gender: "Female",
    primarySport: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    additionalSports: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    location: "Miami, USA",
    memberSince: "2020",
    subtitle: "Club",
    image:
      "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=400&h=400&fit=crop",
    rating: 4.9,
    online: false,
    matchesPlayed: 145,
    description:
      " If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
    organisation: [
      { club: "Baseball Club", role: "Team Leader" },
      { club: "Football Club", role: "Member" },
    ],
    certifications: [
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
    ],
  },
  {
    id: 10,
    name: "John Wick",
    type: "playmate",
    age: 33,
    gender: "Male",
    primarySport: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    additionalSports: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    location: "Seattle, USA",
    memberSince: "2020",
    subtitle: "Crew",
    image:
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop",
    rating: 5.0,
    online: true,
    matchesPlayed: 145,
    description:
      " If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
    organisation: [
      { club: "Baseball Club", role: "Team Leader" },
      { club: "Football Club", role: "Member" },
    ],
    certifications: [
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
    ],
  },
  {
    id: 11,
    name: "Scarlett J",
    type: "playmate",
    age: 33,
    gender: "Female",
    primarySport: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    additionalSports: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    location: "Boston, USA",
    memberSince: "2020",
    subtitle: "Venue",
    image:
      "https://images.unsplash.com/photo-1525134479668-1bee5c7c6845?w=400&h=400&fit=crop",
    rating: 4.8,
    online: true,
    matchesPlayed: 145,
    description:
      " If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
    organisation: [
      { club: "Baseball Club", role: "Team Leader" },
      { club: "Football Club", role: "Member" },
    ],
    certifications: [
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
    ],
  },
  {
    id: 12,
    name: "John Wick",
    type: "playmate",
    age: 33,
    gender: "Male",
    primarySport: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    additionalSports: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    location: "Seattle, USA",
    memberSince: "2020",
    subtitle: "Crew",
    image:
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop",
    rating: 5.0,
    online: true,
    matchesPlayed: 145,
    description:
      " If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
    organisation: [
      { club: "Baseball Club", role: "Team Leader" },
      { club: "Football Club", role: "Member" },
    ],
    certifications: [
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
      {
        category: "Certification",
        title: "My Title",
        issuingOrganization: "Issuing Organization",
        level: "State/Regional",
        date: "2025-09-27",
        validity: "2025-09-25",
        description: " Point 1\n- Point 2\n- Point 3",
        proof:
          "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=300&h=200&fit=crop",
      },
    ],
  },
  {
    id: 13,
    name: "Scarlett J",
    type: "playmate",
    age: 33,
    gender: "Female",
    primarySport: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    additionalSports: [
      "Football",
      "Basketball",
      "Badminton",
      "Auto Racing",
      "American Football",
    ],
    organisation: [
      {
        club: "Club 1",
        role: "Role 1",
      },
      {
        club: "Club 2",
        role: "Role 3",
      },
      {
        club: "Club 3",
        role: "Role 3",
      },
      {
        club: "Club 4",
        role: "Role 4",
      },
    ],
    location: "Boston, USA",
    memberSince: "2020",
    subtitle: "Venue",
    image:
      "https://images.unsplash.com/photo-1525134479668-1bee5c7c6845?w=400&h=400&fit=crop",
    rating: 4.8,
    online: true,
    matchesPlayed: 145,
    description:
      " If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
  },
];

export const dropdownItems = ["Player", "Club", "Crew", "Venue"];

export const userType = [
  {
    name: "🏃‍♂️ Player",
    id: 2,
  },
  {
    name: "👥 Club/Academy",
    disable: false,
    id: 3,
  },
  // {
  //   name: '📦 Crew',
  //   id: 4
  // },
  {
    name: "🏟️ Venue",
    disable: false,
    id: 5,
  },
];
export const FILTER_USER_TYPES = [
  {
    name: "Player",
    id: 2,
  },
  {
    name: "Club",
    id: 3,
  },
  {
    name: "Crew",
    id: 4,
  },
  {
    name: "Venue",
    id: 5,
  },
];
export const roles = {
  CLUB: 3,
  VENUE: 5,
  PLAYER: 2,
  CREW: 4,
};

export const token = secureLocalStorage.getItem(
  process.env.REACT_APP_TOKEN_STORAGE_KEY
);

export const fcmToken = secureLocalStorage.getItem(
  process.env.REACT_APP_FCM_TOKEN_KEY
)
  ? secureLocalStorage.getItem(process.env.REACT_APP_FCM_TOKEN_KEY)
  : Cookies.get(process.env.REACT_APP_FCM_TOKEN_KEY);

export const userData = secureLocalStorage.getItem(
  process.env.REACT_APP_USER_STORAGE_KEY
);

export const USERS_LIST = secureLocalStorage.getItem(
  process.env.REACT_APP_USERS_LIST_KEY
);

export const APP_CONSTANT = {
  PRIVACY_POLICY_URL: "https://playmatez.io/privacy-policy",
  HELP_URL: "https://playmatez.io/support-hub",
};

export const VENUE_TYPE = {
  PRIVATE: 1,
  PUBLIC: 3,
  NORMAL: 2,
};

export const PRIMARY_TYPE = {
  CLUB: "club",
  ACADEMY: "academy",
};

export const purchaseData = [
  {
    id: 1,
    user: {
      name: "Amit Sharma",
      image: profile1,
    },
    creationDate: "2025-01-02",
    dateOfBooking: "2025-01-02",
    venue: "Royal Palace",
    price: 233,
    location: "Mumbai, Maharashtra, India",
    refrenceId: "FOT1234567890",
    productCountry: "India",
    productTitle: "Urban Property Insights Package",
    ProductDescription:
      "Premium service package tailored for urban property insights and analytics.",
    images: [
      "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1570129477492-45c003edd2be?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?auto=format&fit=crop&w=1200&q=80",
    ],
  },
  {
    id: 2,
    user: {
      name: "Neha Verma",
      image: profile2,
    },
    creationDate: "2025-01-03",
    dateOfBooking: "2025-01-03",
    venue: "Sunset Banquet",
    price: 450,
    refrenceId: "TNS1234567891",
    location: "Delhi, India",
    productCountry: "India",
    productTitle: "Metro Data Intelligence Suite",
    ProductDescription:
      "Comprehensive data solution designed for high-demand metropolitan regions.",
    images: [
      "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1493809842364-78817add7ffb?auto=format&fit=crop&w=1200&q=80",
    ],
  },
  {
    id: 3,
    user: {
      name: "Rahul Mehta",
      image: profile5,
    },
    creationDate: "2025-01-04",
    dateOfBooking: "2025-01-04",
    venue: "Green Garden",
    price: 300,
    refrenceId: "BDM1234567892",
    location: "Bangalore, Karnataka, India",
    productCountry: "India",
    productTitle: "Tech Hub Location Analytics",
    ProductDescription:
      "Technology-focused service offering accurate location-based intelligence.",
    images: [
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1200&q=80",
    ],
  },
  {
    id: 4,
    user: {
      name: "Priya Singh",
      image: profile1,
    },
    creationDate: "2025-01-05",
    dateOfBooking: "2025-01-05",
    price: 500,
    venue: "Crystal Hall",
    refrenceId: "BSK1234567893",
    location: "Kolkata, West Bengal, India",
    productCountry: "India",
    productTitle: "Regional Market Research Pro",
    ProductDescription:
      "Advanced market research package optimized for regional markets.",
    images: [
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1200&q=80",
    ],
  },
  {
    id: 5,
    user: {
      name: "Vikas Kumar",
      image: profile5,
    },
    dateOfBooking: "2025-01-06",
    creationDate: "2025-01-06",
    price: 650,
    venue: "Ocean View",
    refrenceId: "CRT1234567894",
    location: "Chennai, Tamil Nadu, India",
    productCountry: "India",
    productTitle: "Enterprise Coverage Intelligence",
    ProductDescription:
      "High-value enterprise solution with extended coverage and premium insights.",
    images: [
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1200&q=80",
    ],
  },
  {
    id: 6,
    user: {
      name: "Anjali Gupta",
      image: profile3,
    },
    dateOfBooking: "2025-01-07",
    creationDate: "2025-01-07",
    price: 280,
    venue: "Lotus Banquet",
    refrenceId: "HKY1234567895",
    location: "Pune, Maharashtra, India",
    productCountry: "India",
    productTitle: "Growth City Data Pack",
    ProductDescription:
      "Cost-effective data service ideal for fast-growing business hubs.",
    images: [
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1200&q=80",
    ],
  },
  {
    id: 7,
    user: {
      name: "Rohit Jain",
      image: profile5,
    },
    dateOfBooking: "2025-01-08",
    creationDate: "2025-01-08",
    venue: "Silver Star Hall",
    price: 420,
    refrenceId: "FOT1234567896",
    location: "Hyderabad, Telangana, India",
    productCountry: "India",
    productTitle: "Balanced Market Analytics",
    ProductDescription:
      "Balanced analytics package combining precision, speed, and reliability.",
    images: [
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1200&q=80",
    ],
  },
  {
    id: 8,
    user: {
      name: "Sneha Kapoor",
      image: profile4,
    },
    dateOfBooking: "2025-01-09",
    creationDate: "2025-01-09",
    price: 390,
    venue: "Pearl Palace",
    refrenceId: "VBL1234567897",
    location: "Ahmedabad, Gujarat, India",
    productCountry: "India",
    productTitle: "Emerging Region Intelligence",
    ProductDescription:
      "Region-specific solution crafted for emerging commercial ecosystems.",
    images: [
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1200&q=80",
    ],
  },
  {
    id: 9,
    user: {
      name: "Kunal Shah",
      image: profile5,
    },
    dateOfBooking: "2025-01-10",
    creationDate: "2025-01-10",
    venue: "Golden Crown",
    price: 550,
    refrenceId: "CRT1234567898",
    location: "Surat, Gujarat, India",
    productCountry: "India",
    productTitle: "Industrial Market Analytics Pro",
    ProductDescription:
      "Premium analytics offering focused on industrial and trade-centric markets.",
    images: [
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1200&q=80",
    ],
  },
  {
    id: 10,
    user: {
      name: "Pooja Malhotra",
      image: profile4,
    },
    dateOfBooking: "2025-01-11",
    creationDate: "2025-01-11",
    venue: "Emerald Hall",
    price: 470,
    refrenceId: "TNS1234567899",
    location: "Jaipur, Rajasthan, India",
    productCountry: "India",
    productTitle: "Global Expansion Insights",
    ProductDescription:
      "Insight-driven service designed for fast-growing international regions.",
    images: [
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1200&q=80",
    ],
  },
];

export const countries = [
  { value: "India", label: "India" },
  { value: "USA", label: "United States" },
  { value: "Canada", label: "Canada" },
  { value: "UK", label: "United Kingdom" },
  { value: "Australia", label: "Australia" },
  { value: "Germany", label: "Germany" },
  { value: "France", label: "France" },
  { value: "Japan", label: "Japan" },
  { value: "China", label: "China" },
  { value: "Brazil", label: "Brazil" },
  { value: "Mexico", label: "Mexico" },
  { value: "South Africa", label: "South Africa" },
  { value: "Russia", label: "Russia" },
  { value: "Italy", label: "Italy" },
  { value: "Spain", label: "Spain" },
  { value: "Argentina", label: "Argentina" },
  { value: "Saudi Arabia", label: "Saudi Arabia" },
  { value: "Egypt", label: "Egypt" },
  { value: "South Korea", label: "South Korea" },
  { value: "Sweden", label: "Sweden" },
];

export const purchaseDetail = [
  {
    id: 1,
    user: {
      name: "Amit Sharma",
    },
    dateOfpurchaseDetail: "2025-01-02",
    venue: "Royal Palace",
    amountPaid: 233,
    sportName: "Football",
    refrenceId: "FOT1234567890",
    location: "Mumbai, Maharashtra, India",
    slots: [
      "00:00 - 01:00",
      "01:00 - 02:00",
      "02:00 - 03:00",
      "03:00 - 04:00",
      "04:00 - 05:00",
      "05:00 - 06:00",
      "06:00 - 07:00",
      "07:00 - 08:00",
      "08:00 - 09:00",
    ],
  },
  {
    id: 2,
    user: {
      name: "Neha Verma",
      image: "profile2",
    },
    dateOfpurchaseDetail: "2025-01-03",
    venue: "Sunset Banquet",
    amountPaid: 450,
    sportName: "Tennis",
    refrenceId: "TNS1234567891",
    location: "Delhi, India",
    slots: [
      "00:00 - 01:00",
      "01:00 - 02:00",
      "02:00 - 03:00",
      "03:00 - 04:00",
      "04:00 - 05:00",
      "05:00 - 06:00",
      "06:00 - 07:00",
      "07:00 - 08:00",
      "08:00 - 09:00",
    ],
  },
  {
    id: 3,
    user: {
      name: "Rahul Mehta",
      image: "profile5",
    },
    dateOfpurchaseDetail: "2025-01-04",
    venue: "Green Garden",
    amountPaid: 300,
    sportName: "Badminton",
    refrenceId: "BDM1234567892",
    location: "Bangalore, Karnataka, India",
    slots: [
      "00:00 - 01:00",
      "01:00 - 02:00",
      "02:00 - 03:00",
      "03:00 - 04:00",
      "04:00 - 05:00",
      "05:00 - 06:00",
      "06:00 - 07:00",
      "07:00 - 08:00",
      "08:00 - 09:00",
    ],
  },
  {
    id: 4,
    user: {
      name: "Priya Singh",
      image: "profile1",
    },
    dateOfpurchaseDetail: "2025-01-05",
    venue: "Crystal Hall",
    amountPaid: 500,
    sportName: "Basketball",
    refrenceId: "BSK1234567893",
    location: "Kolkata, West Bengal, India",
    slots: [
      "00:00 - 01:00",
      "01:00 - 02:00",
      "02:00 - 03:00",
      "03:00 - 04:00",
      "04:00 - 05:00",
      "05:00 - 06:00",
      "06:00 - 07:00",
      "07:00 - 08:00",
      "08:00 - 09:00",
    ],
  },
  {
    id: 5,
    user: {
      name: "Vikas Kumar",
      image: "profile5",
    },
    dateOfpurchaseDetail: "2025-01-06",
    venue: "Ocean View",
    amountPaid: 650,
    sportName: "Cricket",
    refrenceId: "CRT1234567894",
    location: "Chennai, Tamil Nadu, India",
    slots: [
      "00:00 - 01:00",
      "01:00 - 02:00",
      "02:00 - 03:00",
      "03:00 - 04:00",
      "04:00 - 05:00",
      "05:00 - 06:00",
      "06:00 - 07:00",
      "07:00 - 08:00",
      "08:00 - 09:00",
    ],
  },
  {
    id: 6,
    user: {
      name: "Anjali Gupta",
      image: "profile3",
    },
    dateOfpurchaseDetail: "2025-01-07",
    venue: "Lotus Banquet",
    amountPaid: 280,
    sportName: "Hockey",
    refrenceId: "HKY1234567895",
    location: "Pune, Maharashtra, India",
    slots: [
      "00:00 - 01:00",
      "01:00 - 02:00",
      "02:00 - 03:00",
      "03:00 - 04:00",
      "04:00 - 05:00",
      "05:00 - 06:00",
      "06:00 - 07:00",
      "07:00 - 08:00",
      "08:00 - 09:00",
    ],
  },
  {
    id: 7,
    user: {
      name: "Rohit Jain",
      image: "profile5",
    },
    dateOfpurchaseDetail: "2025-01-08",
    venue: "Silver Star Hall",
    amountPaid: 420,
    sportName: "Football",
    refrenceId: "FOT1234567896",
    location: "Hyderabad, Telangana, India",
    slots: [
      "00:00 - 01:00",
      "01:00 - 02:00",
      "02:00 - 03:00",
      "03:00 - 04:00",
      "04:00 - 05:00",
      "05:00 - 06:00",
      "06:00 - 07:00",
      "07:00 - 08:00",
      "08:00 - 09:00",
    ],
  },
  {
    id: 8,
    user: {
      name: "Sneha Kapoor",
      image: "profile4",
    },
    dateOfpurchaseDetail: "2025-01-09",
    venue: "Pearl Palace",
    amountPaid: 390,
    sportName: "Volleyball",
    refrenceId: "VBL1234567897",
    location: "Ahmedabad, Gujarat, India",
    slots: [
      "00:00 - 01:00",
      "01:00 - 02:00",
      "02:00 - 03:00",
      "03:00 - 04:00",
      "04:00 - 05:00",
      "05:00 - 06:00",
      "06:00 - 07:00",
      "07:00 - 08:00",
      "08:00 - 09:00",
    ],
  },
  {
    id: 9,
    user: {
      name: "Kunal Shah",
      image: "profile5",
    },
    dateOfpurchaseDetail: "2025-01-10",
    venue: "Golden Crown",
    amountPaid: 550,
    sportName: "Cricket",
    refrenceId: "CRT1234567898",
    location: "Surat, Gujarat, India",
    slots: [
      "00:00 - 01:00",
      "01:00 - 02:00",
      "02:00 - 03:00",
      "03:00 - 04:00",
      "04:00 - 05:00",
      "05:00 - 06:00",
      "06:00 - 07:00",
      "07:00 - 08:00",
      "08:00 - 09:00",
    ],
  },
  {
    id: 10,
    user: {
      name: "Pooja Malhotra",
      image: "profile4",
    },
    dateOfpurchaseDetail: "2025-01-11",
    venue: "Emerald Hall",
    amountPaid: 470,
    sportName: "Tennis",
    refrenceId: "TNS1234567899",
    location: "Jaipur, Rajasthan, India",
    slots: [
      "00:00 - 01:00",
      "01:00 - 02:00",
      "02:00 - 03:00",
      "03:00 - 04:00",
      "04:00 - 05:00",
      "05:00 - 06:00",
      "06:00 - 07:00",
      "07:00 - 08:00",
      "08:00 - 09:00",
    ],
  },
];

export const TYPES = {
  VENUE_DELETE_TYPE: 13,
  EVENT_DELETE_TYPE: 7,
  SERVICE_DELETE_TYPE: 2,
};

export const sportOptions = [
  { id: 1, name: "Cricket" },
  { id: 2, name: "Football" },
  { id: 3, name: "Tennis" },
  { id: 4, name: "Basketball" },
];

export const gameTypeOption = [
  { id: "indoor", name: "Indoor" },
  { id: "outdoor", name: "Outdoor" },
  { id: "hybrid", name: "Hybrid" },
  { id: "multiSportComplex", name: "Multi-sport Complex" },
];

export const designationOption = [
  { id: "Owner", name: "Owner" },
  { id: "Admin", name: "Admin" },
  { id: "Coach", name: "Coach" },
  { id: "Manager", name: "Manager" },
  { id: "Volunteer", name: "Volunteer" },
  { id: "Other", name: "Other" },
];

export const roleOption = [
  { id: 1, name: "Owner" },
  { id: 2, name: "Admin" },
  { id: 3, name: "Staff" },
  { id: 4, name: "Viewer" },
];

export const categoryOption = [
  { id: "Achievement", name: "🏆 Achievement" },
  { id: "Certification", name: "📜 Certification" },
  { id: "Award", name: "🏅 Award" },
  { id: "Qualification", name: "🎓 Qualification" },
  { id: "Milestone", name: "🎯 Milestone" },
];

export const levelOption = [
  { id: "Local", name: "Local" },
  { id: "State/Regional", name: "State/Regional" },
  { id: "National", name: "National" },
  { id: "International", name: "International" },
];

export const violationOption = ["Scam", "Harassment", "Abuse", "Abuse"];

export const USER_TYPE = {
  2: "Player",
  5: "Venue",
  3: "Club",
  4: "Crew",
};

export const my_Posting = [
  {
    id: 1,
    title: "Event Card",
    image: gameIcon,
    viewText: "View Details",
    organizer: "John Doe",
    organizerImage: partner,
    testImage: notepad,
    category: "Badminton",
    categoryImg: badminton,
    date: "2026-02-10",
    location: "Downtown Sports Club",
    number: 0,
  },
  {
    id: 2,
    title: "Event Card",
    image: gameIcon,
    viewText: "View Details",
    organizer: "Jane Smith",
    organizerImage: partner,
    testImage: notepad,
    categoryImg: badminton,
    category: "Tennis",
    date: "2026-02-12",
    location: "Green Valley Courts",
    number: 0,
  },
  {
    id: 3,
    title: "Event Card",
    image: gameIcon,
    viewText: "View Details",
    organizer: "Mike Johnson",
    organizerImage: partner,
    category: "Football",
    testImage: notepad,
    categoryImg: badminton,
    date: "2026-02-15",
    location: "City Stadium",
    number: 0,
  },
  {
    id: 4,
    title: "Event Card",
    image: gameIcon,
    viewText: "View Details",
    organizer: "Emily Davis",
    organizerImage: partner,
    testImage: notepad,
    categoryImg: badminton,
    category: "Cricket",
    date: "2026-02-18",
    location: "West End Ground",
    number: 0,
  },
  {
    id: 5,
    title: "Event Card",
    image: gameIcon,
    viewText: "View Details",
    organizer: "David Lee",
    organizerImage: partner,
    testImage: notepad,
    categoryImg: badminton,
    category: "Basketball",
    date: "2026-02-20",
    location: "Riverside Arena",
    number: 0,
  },
  {
    id: 6,
    title: "Event Card",
    image: gameIcon,
    viewText: "View Details",
    organizer: "Sophia Brown",
    organizerImage: partner,
    testImage: notepad,
    categoryImg: badminton,
    category: "Volleyball",
    date: "2026-02-22",
    location: "Beachside Court",
    number: 0,
  },
  {
    id: 7,
    title: "Event Card",
    image: gameIcon,
    viewText: "View Details",
    organizer: "Chris Wilson",
    organizerImage: partner,
    testImage: notepad,
    categoryImg: badminton,
    category: "Badminton",
    date: "2026-02-25",
    location: "Community Center",
    number: 0,
  },
  {
    id: 8,
    title: "Event Card",
    image: gameIcon,
    viewText: "View Details",
    organizer: "Olivia Martinez",
    organizerImage: partner,
    testImage: notepad,
    categoryImg: badminton,
    category: "Tennis",
    date: "2026-02-28",
    location: "Elite Tennis Club",
    number: 0,
  },
  {
    id: 9,
    title: "Event Card",
    image: gameIcon,
    viewText: "View Details",
    organizer: "Daniel Taylor",
    organizerImage: partner,
    testImage: notepad,
    categoryImg: badminton,
    category: "Football",
    date: "2026-03-05",
    location: "North Park Field",
    number: 0,
  },
  {
    id: 10,
    title: "Event Card",
    image: gameIcon,
    viewText: "View Details",
    organizer: "Mia Anderson",
    organizerImage: partner,
    testImage: notepad,
    categoryImg: badminton,
    category: "Cricket",
    date: "2026-03-10",
    location: "Central Cricket Hub",
    number: 0,
  },
];

export const MESSAGE_TYPES = {
  TEXT: "text",
  LOCATION: "location",
  IMAGE: "image",
  SYSTEM: "system",
};

export const CHAT_TYPES = {
  CARDS: "cards",
  CONNECTIONS: "connections",
  GROUPS: "groups",
  MARKETPLACE: "marketplace",
};

export const card_Details_Data = [
  {
    id: "1",
    title: "Elite Youth Football Clinic",
    organizer: "Indore Sports Academy",
    image: "https://images.unsplash.com/photo-1552667466-07770ae110d0?w=400",
    game: "American Football",
    age: "Ages 13-18",
    gender: "Female",
    location: "Emerald Heights Grounds, Indore",
    date_time: "10/01/2026 | 09:00 AM", // Added Time
    description:
      "A high-intensity training camp focusing on tactical gameplay and physical conditioning.",
    requirement: "Full safety gear and active insurance required.",
    contact_no: "9993992423",
    fee: "$ 125.00",
    live_availability: "Yes",
  },
  {
    id: "2",
    title: "Inter-City Basketball Open",
    organizer: "Hoop Dreams Foundation",
    image: "https://images.unsplash.com/photo-1546519638-68e109498ffc?w=400",
    game: "Basketball",
    age: "Ages 18-25",
    gender: "Mixed",
    location: "Nehru Stadium, Indore",
    date_time: "15/01/2026 | 04:30 PM", // Added Time
    description: "3v3 tournament format with a focus on streetball skills.",
    requirement: "Standard basketball jersey and indoor court shoes.",
    contact_no: "9826012345",
    fee: "$ 50.00",
    live_availability: "No",
  },
  {
    id: "3",
    title: "Premier Cricket Trials",
    organizer: "MP Cricket Association",
    image: "https://images.unsplash.com/photo-1531415074968-036ba1b575da?w=400",
    game: "Cricket",
    age: "Under 16",
    gender: "Male",
    location: "Holkar Stadium, Indore",
    date_time: "20/01/2026 | 07:00 AM", // Added Time
    description: "Selection trials for the upcoming regional summer league.",
    requirement: "White kit and personal batting/bowling equipment.",
    contact_no: "9425098765",
    fee: "$ 20.00",
    live_availability: "Yes",
  },
  {
    id: "4",
    title: "Sunshine Tennis Invitational",
    organizer: "Global Tennis Hub",
    image: "https://images.unsplash.com/photo-1622279457486-62dcc4a4bd13?w=400",
    game: "Tennis",
    age: "All Ages",
    gender: "Female",
    location: "Indore Residency Club",
    date_time: "22/01/2026 | 10:00 AM", // Added Time
    description: "A weekend knockout tournament for amateur female players.",
    requirement: "Tennis racket and non-marking soles.",
    contact_no: "8889976543",
    fee: "$ 75.00",
    live_availability: "Yes",
  },
  {
    id: "5",
    title: "Golden Goal Soccer Meet",
    organizer: "United Footballers",
    image: "https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=400",
    game: "Soccer",
    age: "Ages 10-15",
    gender: "Male",
    location: "Vijay Nagar Sports Complex",
    date_time: "28/01/2026 | 05:00 PM", // Added Time
    description:
      "Friendly community matches to promote youth soccer participation.",
    requirement: "Shin guards and soccer cleats are mandatory.",
    contact_no: "7771122334",
    fee: "Free",
    live_availability: "No",
  },
  {
    id: "6",
    title: "Apex Badminton League",
    organizer: "Shuttle Masters",
    image: "https://images.unsplash.com/photo-1626225967045-9410ee753702?w=400",
    game: "Badminton",
    age: "Adults",
    gender: "Mixed",
    location: "Sayaji Club Courts",
    date_time: "02/02/2026 | 06:00 PM", // Added Time
    description: "Competitive doubles league with seasonal rankings.",
    requirement: "Personal rackets; shuttles will be provided.",
    contact_no: "9111222333",
    fee: "$ 40.00",
    live_availability: "Yes",
  },
  {
    id: "7",
    title: "Strike Zone Bowling Night",
    organizer: "Bowling Alley Indore",
    image: "https://images.unsplash.com/photo-1541252260730-0412e8e2108e?w=400",
    game: "Bowling",
    age: "Ages 16+",
    gender: "Mixed",
    location: "Treasure Island Mall",
    date_time: "05/02/2026 | 08:30 PM", // Added Time
    description: "Casual bowling competition with prizes for highest scores.",
    requirement: "Bowling shoes (available for rent at venue).",
    contact_no: "9000123456",
    fee: "$ 30.00",
    live_availability: "No",
  },
  {
    id: "8",
    title: "Checkmate Chess Open",
    organizer: "Indore Chess Club",
    image: "https://images.unsplash.com/photo-1529699211952-734e80c4d42b?w=400",
    game: "Chess",
    age: "All Ages",
    gender: "Mixed",
    location: "Public Library Hall, Rajwada",
    date_time: "10/02/2026 | 11:00 AM", // Added Time
    description: "FIDE rated tournament for professional and amateur players.",
    requirement: "Registration on the chess portal before entry.",
    contact_no: "9300554433",
    fee: "$ 15.00",
    live_availability: "Yes",
  },
  {
    id: "9",
    title: "Iron Grip Wrestling Seminar",
    organizer: "Grapple Pro",
    image: "https://images.unsplash.com/photo-1555597673-b21d5c935865?w=400",
    game: "Wrestling",
    age: "Ages 18-35",
    gender: "Male",
    location: "Bada Ganpati Akhada",
    date_time: "12/02/2026 | 06:30 AM", // Added Time
    description: "Technical workshop focusing on freestyle wrestling escapes.",
    requirement: "Proper wrestling singlet or tight athletic wear.",
    contact_no: "9755011223",
    fee: "$ 60.00",
    live_availability: "Yes",
  },
  {
    id: "10",
    title: "Velodrome Cycling Sprint",
    organizer: "Indore Cyclists Group",
    image: "https://images.unsplash.com/photo-1541625602330-2277a4c46182?w=400",
    game: "Cycling",
    age: "Adults",
    gender: "Mixed",
    location: "Super Corridor Road",
    date_time: "15/02/2026 | 05:45 AM", // Added Time
    description: "A 20km time-trial race for cycling enthusiasts.",
    requirement: "Helmet and road-worthy bicycle mandatory.",
    contact_no: "9893000111",
    fee: "$ 10.00",
    live_availability: "No",
  },
];

export const notification = [
  {
    icon: profile1,
    noti: "It has roots in a piece of classical Latin literature from 45 BC.",
    date: "01/02/26 13:19",
    view: "View Profile",
  },
  {
    icon: profile2,
    noti: "when an unknown printer took a galley of type and scrambled.",
    date: "01/02/26 14:15",
    view: "View Profile",
  },
  {
    icon: profile3,
    noti: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
    date: "01/02/26 10:10",
    view: "View Profile",
  },
  {
    icon: profile4,
    noti: "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters",
    date: "01/02/26 20:30",
    view: "View Profile",
  },
  {
    icon: profile5,
    noti: " If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. ",
    date: "01/02/26 15:19",
    view: "View Profile",
  },
  {
    icon: profile1,
    noti: "we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment.",
    date: "01/02/26 19:19",
    view: "View Profile",
  },
  {
    icon: profile5,
    noti: " If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. ",
    date: "01/02/26 15:19",
    view: "View Profile",
  },
  {
    icon: profile1,
    noti: "we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment.",
    date: "01/02/26 19:19",
    view: "View Profile",
  },
  {
    icon: profile5,
    noti: " If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. ",
    date: "01/02/26 15:19",
    view: "View Profile",
  },
  {
    icon: profile1,
    noti: "we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment.",
    date: "01/02/26 19:19",
    view: "View Profile",
  },
];

export const users = [
  { id: 1, name: "Alex Rivera", avatar: "https://i.pravatar.cc/150?u=1" },
  { id: 2, name: "Jordan Smith", avatar: "https://i.pravatar.cc/150?u=2" },
  { id: 3, name: "Sam Wilson", avatar: "https://i.pravatar.cc/150?u=3" },
  { id: 4, name: "Taylor Otwell", avatar: "https://i.pravatar.cc/150?u=4" },
  { id: 1, name: "Alex Rivera", avatar: "https://i.pravatar.cc/150?u=1" },
  { id: 2, name: "Jordan Smith", avatar: "https://i.pravatar.cc/150?u=2" },
  { id: 3, name: "Sam Wilson", avatar: "https://i.pravatar.cc/150?u=3" },
  { id: 4, name: "Taylor Otwell", avatar: "https://i.pravatar.cc/150?u=4" },
  { id: 1, name: "Alex Rivera", avatar: "https://i.pravatar.cc/150?u=1" },
  { id: 2, name: "Jordan Smith", avatar: "https://i.pravatar.cc/150?u=2" },
  { id: 3, name: "Sam Wilson", avatar: "https://i.pravatar.cc/150?u=3" },
  { id: 4, name: "Taylor Otwell", avatar: "https://i.pravatar.cc/150?u=4" },
];

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const accessibility = [
  "Wheelchair Friendly",
  "Vision Impaired",
  "Deaf Friendly",
  "Intellectual Disabilities",
  "All Abilities",
];

export const no_player = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
];

export const ageGroup = [
  "Children under the age of 6",
  "Ages 8-12",
  "Ages 13-18",
  "Ages 19 and above",
  "Other",
];

export const CARD_BRAND_LABELS = {
  visa: "Visa",
  mastercard: "Mastercard",
  american_express: "American Express",
  amex: "American Express",
  discover: "Discover",
  diners_club: "Diners Club",
  jcb: "JCB",
  unionpay: "UnionPay",
  cartesian: "Cartesian",
  elo: "Elo",
  hipercard: "Hipercard",
  mir: "MIR",
  unknown: "Card",
};

export const venueSearch = [
  {
    venueImg: "https://picsum.photos/300/200?random=1",
    name: "Royal Palace Banquet",
  },
  {
    venueImg: "https://picsum.photos/300/200?random=2",
    name: "Sunset Garden Venue",
  },
  {
    venueImg: "https://picsum.photos/300/200?random=3",
    name: "Grand Orchid Hall",
  },
  {
    venueImg: "https://picsum.photos/300/200?random=4",
    name: "Lakeside Convention Center",
  },
  {
    venueImg: "https://picsum.photos/300/200?random=5",
    name: "Emerald Ballroom",
  },
  {
    venueImg: "https://picsum.photos/300/200?random=6",
    name: "Silver Oak Resort",
  },
  {
    venueImg: "https://picsum.photos/300/200?random=7",
    name: "Crystal Crown Venue",
  },
  {
    venueImg: "https://picsum.photos/300/200?random=8",
    name: "The Heritage Courtyard",
  },
  {
    venueImg: "https://picsum.photos/300/200?random=9",
    name: "Skyline Rooftop Lounge",
  },
];

export const accordion = [
  {
    header: "What is Lorem Ipsum?",
    options: ["Option 1", "Option 2", "Option 3"],
  },
  {
    header: "Where does it come from?",
    options: ["Yes", "No", "Maybe"],
  },
  {
    header: "Why do we use it?",
    options: ["Because A", "Because B", "Because C"],
  },
];

// crewData.js
export const crewCategories = [
  {
    title: "Coaching & Training",
    options: [
      "Head Coach",
      "Assistant Coach",
      "Skill Coach (Batting / Bowling / Fielding / Goalkeeping etc.)",
      "Fitness Trainer",
      "Strength & Conditioning Coach",
      "Sports Nutritionist",
      "Sports Psychologist",
      "Performance Analyst",
    ],
  },
  {
    title: "Umpiring & Scoring",
    options: [
      "Umpire",
      "Referee",
      "Match Official",
      "Scorer / Statistician",
      "Match Recorder",
      "Video Analyst",
    ],
  },
  {
    title: "Sports Medicine & Recovery",
    options: [
      "Physiotherapist",
      "Sports Chiropractor",
      "Sports Doctor",
      "Athletic Trainer",
      "Recovery Specialist",
      "Masseur/Therapist",
    ],
  },
  {
    title: "Media & Photography",
    options: [
      "Photographer",
      "Videographer",
      "Drone Operator",
      "Live Stream Technician",
      "Commentary Team Member",
      "Socail Media / PR Crew",
    ],
  },
  {
    title: "Event & Operations",
    options: [
      "Event Manager",
      "Tournament Coordinator",
      "Ground Staff / pitch Curator",
      "Equipment Manager",
      "Logistics Assistant",
      "Volunteer / Support Crew",
    ],
  },
  {
    title: "Specialist Support",
    options: [
      "Data Analyst",
      "Biomechanics Expert",
      "Talent Scout",
      "Technical Consultant",
      "Sports Mentor",
    ],
  },
];

export const soughtOption = ["coach", "Referee", "Umpire", "Physio", "Other"];
export const PURCHASE_TYPE = {
  1: "Market Place",
  2: "Venue Booked",
  3: "Event Booked",
};
export const CARD_TYPE = {
  event: "Event Card",
  PSZ: "Service",
  PVZ: "Venue",
  PCZ: "Join",
  PGZ: "Game-On",
};

export const CARDS_ENUMS = {
  GAME: "PGZ",
  SERVICE: "PSZ",
  JOIN: "PCZ",
  VENUE: "PVZ",
  LISTING: "listing",
  EVENT: "event",
};
export const CARDS_NAVIGATION_ENUMS = {
  event: "event",
  PSZ: "service",
  PVZ: "venue",
  PCZ: "join",
  PGZ: "game",
};

export const NotificationType = {
  CHAT: 1,
  ACCEPT_PLAYER_GAME_ON_CARD_REQUEST: 2,
  ACCEPT_PLAYER_VENUE_CARD_REQUEST: 3,
  ACCEPT_PLAYER_CLUB_CARD_REQUEST: 4,
  SEND_PLAYER_GAME_ON_CARD_REQUEST_NOTIFICATION: 5,
  SEND_PLAYER_CLUB_GAME_ON_CARD_REQUEST_NOTIFICATION: 6,
  SEND_PLAYER_CREW_EVENT_REQUEST_NOTIFICATION: 7,
  SEND_PLAYER_VENUE_EVENT_REQUEST_NOTIFICATION: 8,
  ACCEPT_PLAYER_SERVICE_CARD_REQUEST: 9,
  SEND_CONNECTION_REQUEST_NOTIFICATION: 10,
  SEND_NOTIFICATION_ON_REELS_NOTIFICATION: 11,
  REJECT_CONNECTION_REQUEST: 12,
  PLAYER_REJECT_GAME_ON_REQUEST: 13,
  PLAYER_REJECT_VENUE_CARD_REQUEST: 14,
  PLAYER_REJECT_JOIN_CARD_REQUEST: 15,
  PLAYER_REJECT_SERVICE_CARD_REQUEST: 16,
  SELECT_CREW_OR_ASSOCIAN: 17,
  SELECT_CLUB_OR_ACADEMY: 18,
  SELECT_VENUE_INTEREST: 19,
  SEND_CLUB_PLAYER_JOIN_CARD_REQUEST_NOTIFICATION: 20,
  SEND_CLUB_TO_CLUB_JOIN_CARD_REQUEST_NOTIFICATION: 21,
  SEND_CLUB_CREW_EVENT_REQUEST_NOTIFICATION: 22,
  SEND_CLUB_VENUE_EVENT_REQUEST_NOTIFICATION: 23,
  SEND_CREW_PLAYER_SERVICE_CARD_REQUEST_NOTIFICATION: 24,
  SEND_CREW_CLUB_SERVICE_CARD_REQUEST_NOTIFICATION: 25,
  SEND_CREW_VENUE_SERVICE_CARD_REQUEST_NOTIFICATION: 26,
  SEND_VENUE_PLAYER_VENUE_CARD_REQUEST_NOTIFICATION: 27,
  SEND_VENUE_CLUB_VENUE_CARD_REQUEST_NOTIFICATION: 28,
  SEND_VENUE_CREW_EVENT_REQUEST_NOTIFICATION: 29,
  CLUB_ACCEPT_GAME_ON_CARD_REQUEST: 30,
  CLUB_ACCEPT_PLAYER_SERVICE_CARD_REQUEST: 31,
  CLUB_ACCEPT_CLUB_JOIN_CARD_REQUEST: 32,
  CLUB_ACCEPT_VENUE_CARD_REQUEST: 33,
  CREW_ACCEPT_PLAYER_EVENT_REQUEST: 34,
  CREW_ACCEPT_CLUB_EVENT_REQUEST: 35,
  CREW_ACCEPT_VENUE_EVENT_REQUEST: 36,
  VENUE_ACCEPT_PLAYER_EVENT_REQUEST: 37,
  VENUE_ACCEPT_CLUB_EVENT_REQUEST: 38,
  VENUE_ACCEPT_SERVICE_CARD_REQUEST: 39,
  CLUB_REJECT_GAME_ON_CARD_REQUEST: 40,
  CLUB_REJECT_SERVICE_CARD_REQUEST: 41,
  CLUB_REJECT_CLUB_TO_CLUB_JOIN_REQUEST: 42,
  CLUB_REJECT_VENUE_CARD_REQUEST: 43,
  CREW_REJECT_PLAYER_EVENT_REQUEST: 44,
  CREW_REJECT_CLUB_EVENT_REQUEST: 45,
  CREW_REJECT_VENUE_EVENT_REQUEST: 46,
  VENUE_REJECT_PLAYER_EVENT_REQUEST: 47,
  VENUE_REJECT_CLUB_EVENT_REQUEST: 48,
  VENUE_REJECT_SERVICE_CARD_REQUEST: 49,
  SEND_PLAYER_TO_PLAYER_CONNECTION_REQUEST_NOTIFICATION: 50,
  SEND_CLUB_TO_CLUB_CONNECTION_REQUEST_NOTIFICATION: 51,
  SEND_CLUB_TO_PLAYER_CONNECTION_REQUEST_NOTIFICATION: 52,
  SEND_CLUB_TO_CREW_CONNECTION_REQUEST_NOTIFICATION: 53,
  SEND_CLUB_TO_VENUE_CONNECTION_REQUEST_NOTIFICATION: 54,
  SEND_CREW_TO_CLUB_CONNECTION_REQUEST_NOTIFICATION: 55,
  SEND_CREW_TO_PLAYER_CONNECTION_REQUEST_NOTIFICATION: 56,
  SEND_CREW_TO_CREW_CONNECTION_REQUEST_NOTIFICATION: 57,
  SEND_CREW_TO_VENUE_CONNECTION_REQUEST_NOTIFICATION: 58,
  SEND_VENUE_TO_CLUB_CONNECTION_REQUEST_NOTIFICATION: 59,
  SEND_VENUE_TO_PLAYER_CONNECTION_REQUEST_NOTIFICATION: 60,
  SEND_VENUE_TO_CREW_CONNECTION_REQUEST_NOTIFICATION: 61,
  SEND_VENUE_TO_VENUE_CONNECTION_REQUEST_NOTIFICATION: 62,
  PLAYER_ACCEPT_PLAYER_CONNECTION_REQUEST: 63,
  PLAYER_ACCEPT_CLUB_CONNECTION_REQUEST: 64,
  PLAYER_ACCEPT_CREW_CONNECTION_REQUEST: 65,
  PLAYER_ACCEPT_VENUE_CONNECTION_REQUEST: 66,
  CLUB_ACCEPT_CLUB_CONNECTION_REQUEST: 67,
  CLUB_ACCEPT_CREW_CONNECTION_REQUEST: 68,
  CLUB_ACCEPT_VENUE_CONNECTION_REQUEST: 69,
  CREW_ACCEPT_CLUB_CONNECTION_REQUEST: 70,
  CREW_ACCEPT_CREW_CONNECTION_REQUEST: 71,
  CREW_ACCEPT_VENUE_CONNECTION_REQUEST: 72,
  VENUE_ACCEPT_CLUB_CONNECTION_REQUEST: 73,
  VENUE_ACCEPT_CREW_CONNECTION_REQUEST: 74,
  VENUE_ACCEPT_VENUE_CONNECTION_REQUEST: 75,
  USER_FOLLOW_OTHER_USERS: 76,
  CREATE_SCORE_CARD: 77,
  // SEND_PLAYER_TO_CLUB_CONNECTION_REQUEST: 79,
  VENUE_RATING_NOTIFICATION_TO_USER: 103,
  EXPIRED_OR_PAID: 121,
};

const viewProfileNotificationTypes = [
  NotificationType.ACCEPT_PLAYER_GAME_ON_CARD_REQUEST,
  NotificationType.ACCEPT_PLAYER_CLUB_CARD_REQUEST,
  NotificationType.ACCEPT_PLAYER_SERVICE_CARD_REQUEST,
  NotificationType.ACCEPT_PLAYER_VENUE_CARD_REQUEST,
  NotificationType.CLUB_ACCEPT_PLAYER_SERVICE_CARD_REQUEST,
  NotificationType.VENUE_ACCEPT_PLAYER_EVENT_REQUEST,
  NotificationType.PLAYER_ACCEPT_PLAYER_CONNECTION_REQUEST,
  NotificationType.PLAYER_ACCEPT_CLUB_CONNECTION_REQUEST,
  NotificationType.PLAYER_ACCEPT_CREW_CONNECTION_REQUEST,
  NotificationType.PLAYER_ACCEPT_VENUE_CONNECTION_REQUEST,
  NotificationType.CLUB_ACCEPT_CLUB_CONNECTION_REQUEST,
  NotificationType.CLUB_ACCEPT_CREW_CONNECTION_REQUEST,
  NotificationType.CLUB_ACCEPT_VENUE_CONNECTION_REQUEST,
  NotificationType.CREW_ACCEPT_CLUB_CONNECTION_REQUEST,
  NotificationType.CREW_ACCEPT_CREW_CONNECTION_REQUEST,
  NotificationType.CREW_ACCEPT_VENUE_CONNECTION_REQUEST,
  NotificationType.VENUE_ACCEPT_CLUB_CONNECTION_REQUEST,
  NotificationType.VENUE_ACCEPT_CREW_CONNECTION_REQUEST,
  NotificationType.VENUE_ACCEPT_VENUE_CONNECTION_REQUEST,
  NotificationType.USER_FOLLOW_OTHER_USERS,
  NotificationType.CLUB_ACCEPT_GAME_ON_CARD_REQUEST,
  NotificationType.CLUB_ACCEPT_PLAYER_SERVICE_CARD_REQUEST,
  NotificationType.CLUB_ACCEPT_CLUB_JOIN_CARD_REQUEST,
  NotificationType.CLUB_ACCEPT_VENUE_CARD_REQUEST,
  NotificationType.CREW_ACCEPT_PLAYER_EVENT_REQUEST,
  NotificationType.CREW_ACCEPT_CLUB_EVENT_REQUEST,
  NotificationType.CREW_ACCEPT_VENUE_EVENT_REQUEST,
  NotificationType.VENUE_ACCEPT_PLAYER_EVENT_REQUEST,
  NotificationType.VENUE_ACCEPT_CLUB_EVENT_REQUEST,
  NotificationType.VENUE_ACCEPT_SERVICE_CARD_REQUEST,
  NotificationType.CLUB_REJECT_GAME_ON_CARD_REQUEST,
  NotificationType.CLUB_REJECT_SERVICE_CARD_REQUEST,
  NotificationType.CLUB_REJECT_CLUB_TO_CLUB_JOIN_REQUEST,
  NotificationType.CLUB_REJECT_VENUE_CARD_REQUEST,
  NotificationType.CREW_REJECT_PLAYER_EVENT_REQUEST,
  NotificationType.CREW_REJECT_CLUB_EVENT_REQUEST,
  NotificationType.CREW_REJECT_VENUE_EVENT_REQUEST,
  NotificationType.VENUE_REJECT_PLAYER_EVENT_REQUEST,
  NotificationType.VENUE_REJECT_CLUB_EVENT_REQUEST,
  NotificationType.VENUE_REJECT_SERVICE_CARD_REQUEST,
  NotificationType.REJECT_CONNECTION_REQUEST,
  NotificationType.PLAYER_REJECT_GAME_ON_REQUEST,
  NotificationType.PLAYER_REJECT_VENUE_CARD_REQUEST,
  NotificationType.PLAYER_REJECT_JOIN_CARD_REQUEST,
  NotificationType.PLAYER_REJECT_SERVICE_CARD_REQUEST,
  NotificationType.SELECT_CREW_OR_ASSOCIAN,
  NotificationType.SELECT_CLUB_OR_ACADEMY,
  NotificationType.SELECT_VENUE_INTEREST,
  NotificationType.SEND_PLAYER_GAME_ON_CARD_REQUEST_NOTIFICATION,
  NotificationType.SEND_PLAYER_CLUB_GAME_ON_CARD_REQUEST_NOTIFICATION,
  NotificationType.SEND_PLAYER_CREW_EVENT_REQUEST_NOTIFICATION,
  NotificationType.SEND_PLAYER_VENUE_EVENT_REQUEST_NOTIFICATION,
  NotificationType.SEND_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_NOTIFICATION_ON_REELS_NOTIFICATION,
  NotificationType.SEND_CLUB_PLAYER_JOIN_CARD_REQUEST_NOTIFICATION,
  NotificationType.SEND_CLUB_TO_CLUB_JOIN_CARD_REQUEST_NOTIFICATION,
  NotificationType.SEND_CLUB_CREW_EVENT_REQUEST_NOTIFICATION,
  NotificationType.SEND_CLUB_VENUE_EVENT_REQUEST_NOTIFICATION,
  NotificationType.SEND_CREW_PLAYER_SERVICE_CARD_REQUEST_NOTIFICATION,
  NotificationType.SEND_CREW_CLUB_SERVICE_CARD_REQUEST_NOTIFICATION,
  NotificationType.SEND_CREW_VENUE_SERVICE_CARD_REQUEST_NOTIFICATION,
  NotificationType.SEND_VENUE_PLAYER_VENUE_CARD_REQUEST_NOTIFICATION,
  NotificationType.SEND_VENUE_CREW_EVENT_REQUEST_NOTIFICATION,
  NotificationType.SEND_PLAYER_TO_PLAYER_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_CLUB_TO_CLUB_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_CLUB_TO_PLAYER_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_CLUB_TO_CREW_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_CLUB_TO_VENUE_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_CREW_TO_CLUB_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_CREW_TO_PLAYER_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_CREW_TO_CREW_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_CREW_TO_VENUE_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_VENUE_TO_CLUB_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_VENUE_TO_PLAYER_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_VENUE_TO_CREW_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_VENUE_TO_VENUE_CONNECTION_REQUEST_NOTIFICATION,
  NotificationType.SEND_PLAYER_TO_CLUB_CONNECTION_REQUEST,
];

export function isViewProfile(notificationType) {
  if (notificationType == null) return false;
  return viewProfileNotificationTypes.includes(notificationType);
}

export const REQUEST_STATUS = {
  ACCEPT_REQUEST: 1,
  REJECT_REQUEST: 2,
  HIDE_BTN_REQUEST: 4,
};
